import React from "react";
import tw from "twin.macro";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import { useTranslation } from "react-i18next";
import GroupCompanyMarquee from "./GroupCompanyMarquee";
import BgTitle from "components/title/BgTitle";
import SubCompanyProfileMobileView from "./SubCompanyProfileMobileView";
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Grid,
} from "@mui/material";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessIcon from "@mui/icons-material/Business";
const HeaderContainer = tw.div`w-full flex flex-col items-center`;

const companyUrls = [
  [
    "https://www.systemsoft.co.jp/", // "SystemSoft Corporation",
    "", // "Terra Technology Co., Ltd.",
  ],
  [
    "https://kes.tokyo/", // "Knowledge Engineering Co., Ltd. - Minato-ku, Tokyo",
    "http://nippon-asi.com/", // "Japan ASI Co., Ltd. - Taito-ku, Tokyo",
    "https://studio-glam.co.jp/", // "Glam Co., Ltd. - Yokohama City, Kanagawa Prefecture",
  ],
];

export default ({ isXs = false }) => {
  const { t } = useTranslation();
  if (isXs) return <SubCompanyProfileMobileView companyUrls={companyUrls} />;

  const defaultPlans = t("subcompany_plans", { returnObjects: true });
  const getPlanIcon = (index) => {
    switch (index) {
      case 0:
        return <HandshakeIcon />;
      case 1:
        return <GroupsIcon />;
      case 2:
        return <BusinessIcon />;
      default:
        return <BusinessIcon />;
    }
  };

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderContainer>
          <BgTitle text={t("subcompany_profile_title")} isCenter={true} />
        </HeaderContainer>
        {/* Plans Section */}
        <Box sx={{ px: 2, mt: 4 }}>
          <Grid container spacing={3}>
            {Object.keys(defaultPlans).map((key, index) => {
              const plan = defaultPlans[key];
              return (
                <Grid item xs={12} md={6} lg={6} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%", // Ensure all cards have the same height
                      position: "relative",
                      borderRadius: 4,
                      overflow: "hidden",
                      bgcolor: plan.featured
                        ? "primary.main"
                        : "background.paper",
                      boxShadow: (theme) =>
                        plan.featured
                          ? `0 8px 32px ${theme.palette.primary.main}20`
                          : "0 4px 12px rgba(0,0,0,0.05)",
                    }}
                  >
                    {/* Plan Header */}
                    <Box
                      sx={{
                        p: 3,
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "1px solid",
                        borderColor: plan.featured ? "primary.dark" : "divider",
                      }}
                    >
                      <IconButton
                        sx={{
                          mr: 2,
                          bgcolor: plan.featured
                            ? "primary.dark"
                            : "primary.lighter",
                          color: plan.featured ? "white" : "primary.main",
                        }}
                      >
                        {getPlanIcon(index)}
                      </IconButton>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 650,
                            fontSize: "1rem",
                            color: plan.featured ? "white" : "text.primary",
                          }}
                        >
                          {plan.name}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Features List */}
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <List sx={{ p: 0, flex: 1 }}>
                        {plan.features.map((feature, idx) => (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            style={
                              !companyUrls[index][idx]
                                ? { pointerEvents: "none" }
                                : {}
                            }
                            key={idx}
                            href={companyUrls[index][idx]}
                          >
                            <ListItem
                              key={idx}
                              sx={{
                                borderBottom:
                                  idx !== plan.features.length - 1
                                    ? "1px solid"
                                    : "none",
                                borderColor: plan.featured
                                  ? "primary.dark"
                                  : "divider",
                                py: 2,
                              }}
                            >
                              <ListItemIcon sx={{ minWidth: 36 }}></ListItemIcon>
                              <ListItemText
                                primary={feature}
                                sx={{
                                  "& .MuiListItemText-primary": {
                                    color: plan.featured
                                      ? "white"
                                      : "text.primary",
                                    fontSize: "0.7rem",
                                    fontWeight: 500,
                                  },
                                }}
                              />{" "}
                              {companyUrls[index][idx] && (
                                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                              )}
                            </ListItem>
                          </a>
                        ))}
                      </List>
                    </Box>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </ContentWithPaddingXl>
      <GroupCompanyMarquee />
    </Container>
  );
};
